import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Track from '../../tracking/ZorseTicketInspectorTracker';
import { jsx as _jsx } from "react/jsx-runtime";
function CloseButton(props) {
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "close-button-internal",
    onClick: () => {
      Track.moreResultsClosed();
      props.onClick();
    },
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.search.panel.close"
    })
  });
}
CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(CloseButton);